import { render } from "@testing-library/react";
import SSOLogin from "./Login/SSOLogin";
import ModulesSelection from "./ModulesSelection/ModulesSelection";

import { BrowserRouter } from "react-router-dom";
import { Routes } from "react-router-dom";
import { Route } from "react-router-dom";
import NewLogin from "./NewLogin/Index"
import LandingPage from "./LandingPage/LandingPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:identifier" element={<SSOLogin />} />
        {/* <Route path="/" element={<SSOLogin />} /> */}
        <Route path="/" element={<NewLogin />} />
        <Route path="/modulesSelection" element={<LandingPage />} />

        {/* <Route path="/modulesSelection" element={<ModulesSelection />} /> */}
      </Routes>
    </BrowserRouter>
  );
}
export default App;



